// show 是否显示在左侧菜单
// 医院概况
let yygkDic = [
  { path: "/yygk", name: "医院概况" },
  { path: "/yygk", name: "医院简介" },
  { path: "/yygk/xianren", name: "现任领导" },
  { path: "/yygk/yiyuanrongyu", name: "医院荣誉" },
  { path: "/yygk/rencaipeiyang", name: "人才培养" },
  { path: "/yygk/lianmeng", name: "盛京医疗联盟" },
  { path: "/yygk/manyi", name: "第三方满意度调查" },
];

// 医疗特色
let yltsDic = [
  { path: "/ylts/home", name: "医疗特色" },
  // { path: "/ylts/kslist", name: "医疗特色" },
  { path: "/ylts", name: "科室介绍" },
  { path: "/ylts/mingyi", name: "盛京名医" },
  { path: "/ylts/zhuanke", name: "国家临床重点专科" },
  { path: "/ylts/tese", name: "特色医疗中心" },
  { path: "/ylts/huli", name: "护理专业发展" },
  { path: "/ylts/shebei", name: "先进设备" },
];

// 教学科研
let jxkyDic = [
  {
    path: "/jxky/home",
    name: "教学科研",
  },
  {
    path: "/jxky/training",
    name: "培训基地",
  },
  {
    path: "/jxky/professional",
    name: "专业基地",
  },
  {
    path: "/jxky/dynamic",
    name: "培训动态",
  },
  {
    path: "/jxky/gongzuo",
    name: "教学工作",
  },
  {
    path: "/jxky/home",
    name: "科学研究",
  },
  {
    path: "/jxky/yanjiusheng",
    name: "研究生教育",
  },
  {
    path: "/jxky/xueshu",
    name: "学术交流",
  },
  {
    path: "/jxky/zazhi",
    name: "承办杂志",
  },
  {
    path: "/jxky/zdsys",
    name: "重点实验室",
  },
  {
    path: "/jxky/llwyh",
    name: "伦理委员会",
  },
  {
    path: "/jxky/ywlcsyjg",
    name: "药物临床试验机构",
  },
  {
    path: "/jxky/cxjs",
    name: "诚信建设",
  }
];

// 盛京文化
let sjwhDic = [
  { path: "/sjwh", name: "盛京文化" },
  { path: "/sjwh", name: "百年历史" },
  { path: "/sjwh/yuange", name: "院标/办院理念/院训/院歌" },
  // { path: "/sjwh/zhoukan", name: "盛京医讯" },
  // { path: "/sjwh/tv", name: "盛京TV" },
  { path: "/sjwh/yingxiang", name: "盛京映像" },
  // { path: "/sjwh/gushi", name: "盛京医院的故事" },
];

// 志愿服务
let zyfwDic = [
  { path: "/zyfw", name: "志愿服务" },
  { path: "/zyfw", name: "关于我们" },
  { path: "/zyfw/daohang", name: "服务导航" },
  { path: "/zyfw/zhidu", name: "规章制度" },
  { path: "/zyfw/ganyan", name: "志愿者感言" },
  { path: "/zyfw/xiangce", name: "志愿者相册" },
  { path: "/zyfw/jiaru", name: "加入我们" },
];

// 健康教育
let jkjyDic = [
  { path: "/jkjy", name: "健康教育" },
  { path: "/jkjy", name: "内科" },
  { path: "/jkjy/waike", name: "外科" },
  { path: "/jkjy/fuchanke", name: "妇产科" },
  { path: "/jkjy/erke", name: "儿科" },
  { path: "/jkjy/ganranke", name: "感染科" },
  { path: "/jkjy/zhongyike", name: "中医科" },
  { path: "/jkjy/wuguanke", name: "五官科" },
  { path: "/jkjy/xinlike", name: "心理科" },
  { path: "/jkjy/yifu", name: "医辅科室" },
  { path: "/jkjy/qita", name: "其他科室" },
];

// 就医指南
let jyznDic = [
  { path: "/jyzn", name: "就医指南" },
  { path: "/jyzn", name: "就诊须知" },
  { path: "/jyzn/liucheng", name: "门诊就诊流程图" },
  { path: "/jyzn/fenbu", name: "楼层分布" },
  { path: "/jyzn/luxian", name: "乘车路线" },
  { path: "/jyzn/lianxi", name: "联系我们" },
];

// 联系我们
let lxwmDic = [
  { path: "/lxwm/dean", name: "联系我们" },
  { path: "/lxwm/dean", name: "给院长写信" },
  // { path: "/lxwm/letters", name: "来信统计" },
  // { path: "/lxwm/digest", name: "来信选登" },
  // { path: "/lxwm/reply", name: "来信回复" },
  { path: "/lxwm/discipline", name: "纪检监察" },
];

// 盛京看点
let sjkdDic = [
  { path: "/sjkd", name: "盛京看点" },
  { path: "/sjkd/yygg", name: "医院公告" },
  { path: "/sjkd/zbgg", name: "招标公告" },
  { path: "/sjkd/yjszl", name: "预决算专栏" },
  { path: "/sjkd/mtksj", name: "媒体看盛京" },
  { path: "/sjkd/ylzh", name: "医疗纵横" },
];

export {
  yygkDic,
  yltsDic,
  jxkyDic,
  sjwhDic,
  zyfwDic,
  jkjyDic,
  jyznDic,
  lxwmDic,
  sjkdDic,
};
